// src/App.js
import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// 导入页面组件
import Home from './pages/Home'; // ✅ 正确路径
import Auth from './pages/Auth';
import PostDetail from './pages/PostDetail';
import Archive from './pages/Archive';
import About from './pages/About';
import WritePost from './pages/WritePost'; // ✅ 添加这一行
import NotFound from './pages/NotFound';
import { mockPosts } from './api/mockData'; // ✅ 正确导入模拟数据

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [posts, setPosts] = useState(mockPosts);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aboutInfo, setAboutInfo] = useState({});
  const [aboutLoading, setAboutLoading] = useState(false);

  // 模拟加载数据
  useEffect(() => {
    setLoading(true);
    try {
      setPosts(mockPosts);
      setAboutInfo({});
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // 路由依赖函数
  const handleLogin = (userInfo) => setLoggedInUser(userInfo);
  const handleRegister = (userInfo) => setLoggedInUser(userInfo);
  const handleLogout = () => setLoggedInUser(null);
  const handleAddPost = (newPost) => {
    setPosts(prevPosts => [newPost, ...prevPosts]);
  };
  const handleUpdateAboutInfo = (newInfo) => setAboutInfo(newInfo);

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* 首页路由 */}
          <Route
            path="/"
            element={
              loggedInUser ? (
                <Home 
                  posts={posts} 
                  loading={loading} 
                  error={error} 
                  loggedInUser={loggedInUser} 
                  onLogout={handleLogout} 
                />
              ) : (
                <Auth
                  onLogin={handleLogin}
                  onRegister={handleRegister}
                  loggedInUser={loggedInUser}
                  onLogout={handleLogout}
                />
              )
            }
          />

          {/* 登录注册路由 */}
          <Route
            path="/auth"
            element={
              <Auth
                onLogin={handleLogin}
                onRegister={handleRegister}
                loggedInUser={loggedInUser}
                onLogout={handleLogout}
              />
            }
          />

          {/* 文章详情路由 */}
          <Route
            path="/post/:id"
            element={
              <PostDetail
                posts={posts}
                loggedInUser={loggedInUser}
                onLogout={handleLogout}
              />
            }
          />

          {/* 归档路由 */}
          <Route
            path="/archive"
            element={
              <Archive 
                posts={posts} 
                loading={loading} 
                error={error} 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            }
          />

          {/* 关于路由 */}
          <Route
            path="/about"
            element={
              <About 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            }
          />

          {/* 写文章路由 */}
          <Route
            path="/write"
            element={
              loggedInUser ? (
                <WritePost 
                  loggedInUser={loggedInUser} 
                  onLogout={handleLogout} 
                  onAddPost={handleAddPost}
                />
              ) : (
                <Navigate to="/auth" replace />
              )
            }
          />

          {/* 404 页面 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;